import {
    MANUFACTURER_DELETE_OPEN_MODAL,
    MANUFACTURER_DELETE_REQUEST,
    MANUFACTURER_DELETE_RESULT,
} from 'Redux/actionTypes';

export const manufacturerDeleteOpenModal = (open, man) => ({
    type: MANUFACTURER_DELETE_OPEN_MODAL,
    payload: { open, man }
})

export const manufacturerDeleteRequest = (data) => ({
    type: MANUFACTURER_DELETE_REQUEST,
    payload: data
})

export const manufacturerDeleteResult = (data) => ({
    type: MANUFACTURER_DELETE_RESULT,
    payload: data
})